<template>
  <div>
    <div class="footer">
      <div class="message">
        <div>
          <!-- <p>您是第 {{ num }} 位访问者</p> -->
          <p>
            主管单位：中国社会科学院&nbsp;&nbsp;&nbsp;&nbsp;主办单位：中国社会科学院农村发展研究所
          </p>

          <p>地址：北京市东城区建国门内大街5号中国社会科学院《中国农村经济》编辑部</p>
          <p>
            电话：010-85195649&nbsp;&nbsp;&nbsp;&nbsp;电子邮箱：ruraleconomy@cass.org.cn
          </p>
          <p>本网所登载文章仅代表作者观点，不代表本网观点或意见</p>
          <p>保留所有权利，未经允许，不得转载</p>
          <p>技术支持电话：010-63269626</p>
          <div class="btm">
            <a style="text-decoration: none">京ICP备 14060216号-2</a>
          </div>
        </div>
        <div style="margin-left: 130px" class="code">
          <div>
            <img src="@/assets/ewm.jpg" width="130px" />
          </div>
          <p
            style="
              line-height: 24px;
              margin-top: 5px;
              padding-left: 5px;
              text-align: center;
            "
          >
            本刊微信公众号：
          </p>
          <p style="line-height: 24px; text-align: center">ruraleconomy</p>
        </div>
        <!--
        <div style="margin-left: 50px" class="code">
          <div>
            <img src="@/assets/images/dy1.png" width="130px" />
          </div>
          <p
            style="
              line-height: 24px;
              margin-top: 5px;
              padding-left: 5px;
              text-align: center;
            "
          >
            本刊订阅电话:
          </p>
          <p style="line-height: 24px; text-align: center">010-59366555</p>
        </div> -->
      </div>
      <!-- <div class="line"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      num: 0,
    };
  },
  created() {
    this.$post("SiteWebApi/GetSiteAccessCount", {}).then((res) => {
      this.num = res.data;
    });
  },
};
</script>

<style lang="less" scoped>
.footer {
  margin-top: 24px;
  min-width: 1400px;
  padding: 60px 0 100px;
  background: url("@/assets/footerBg.png");
  color: #fff;
  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    > div:first-of-type {
      position: relative;
      p {
        font-family: PingFangSC, PingFang SC;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
      }
    }
    .code {
      p {
        // margin-top: 20px;
        color: #fff;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
      }
    }
  }
  .line {
    margin-top: 30px;
    border-bottom: 1px dashed #979797;
    opacity: 0.6;
  }
}

.btm {
  position: absolute;
  margin-top: 20px;
  height: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 14px;
  color: #fcfdff;
  line-height: 25px;
  text-align: center;
  font-style: normal;
  left: 50%;
  transform: translateX(-50%);
  bottom: -70px;
  a {
    color: #fcfdff;
    cursor: pointer;
  }
}
</style>
